import Vue from "vue";
import VueCookies from "vue-cookies";

import PopupSide from "../../vue-components/PopupSide.vue";
import PopupTop from "../../vue-components/PopupTop.vue";

const popup = () => {
  if (document.querySelector("#popup-side")) {
    Vue.config.productionTip = false;
    Vue.config.devtools = false;
    Vue.use(VueCookies);
    Vue.$cookies.config("30d");

    new Vue({
      el: "#popup-side",
      render: (h) => h(PopupSide),
    });
  }

  if (document.querySelector("#popup-top")) {
    Vue.config.productionTip = false;
    Vue.config.devtools = false;
    Vue.use(VueCookies);
    Vue.$cookies.config("30d");

    new Vue({
      el: "#popup-top",
      render: (h) => h(PopupTop),
    });
  }
};

export default popup;
